import { VStack } from '@chakra-ui/react'
import { NodeProps } from '@xyflow/react'
import React from 'react'

import { WaitNodeData } from '../../converters/shared/reactFlowTypes'
import { useSwitchboardT } from '../../types'
import { text } from '../../utils/text'
import { NodeCheckbox, NodeInput } from '../core'
import { BaseNode, nodePropsAreEqual } from './BaseNode'
import { useWaitNode } from './hooks/useWaitNode'

export interface WaitNodeProps extends NodeProps {
  onDelete?: () => void
  onDeleteNode?: (nodeId: string) => void

  showDeleteButton?: boolean
}

const WaitNodeComponent: React.FC<WaitNodeProps> = ({
  id,
  data,
  onDelete,
  onDeleteNode,
  showDeleteButton,
}) => {
  const nodeData = data as WaitNodeData & Record<string, unknown>
  const {
    currentDuration,
    currentRingDuringWait,
    handleDurationChange,
    handleDurationBlur,
    handleDurationIncrement,
    handleDurationDecrement,
    handleRingDuringWaitChange,
    hasData,
  } = useWaitNode(id, nodeData)
  const t = useSwitchboardT()

  return (
    <BaseNode
      label={text(t, 'switchboard.nodeLabels.wait', 'WAIT')}
      showPlaceholder={!hasData}
      onDelete={onDelete}
      onDeleteNode={onDeleteNode}
      id={id}
      showDeleteButton={showDeleteButton}
    >
      <VStack align="stretch" gap={3}>
        <NodeInput
          label={text(t, 'switchboard.nodes.wait.duration', 'Duration')}
          type="number"
          value={currentDuration}
          onChange={(e) => handleDurationChange(e.target.value)}
          onBlur={handleDurationBlur}
          onIncrement={handleDurationIncrement}
          onDecrement={handleDurationDecrement}
          placeholder="5"
          min={1}
          max={60}
        />

        <NodeCheckbox
          label={text(
            t,
            'switchboard.nodes.wait.ringDuringWait',
            'Ring During Wait',
          )}
          checked={currentRingDuringWait}
          onChange={(e) => handleRingDuringWaitChange(e.target.checked)}
        />
      </VStack>
    </BaseNode>
  )
}

export const WaitNode = React.memo(WaitNodeComponent, nodePropsAreEqual)
